<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.opportunityQuestionCategoryID" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Abbreviation</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.abbreviation" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Description</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.description" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Sort Order</label>
                <input type="number" class="form-control" [(ngModel)]="tableItem.sortOrder" min="1" step="1" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Retired</label>
                <input type="checkbox" id="retired" name="retired" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.retired" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
